import React from 'react';

const EditReportIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0758 0.221937C15.3717 -0.073979 15.8156 -0.073979 16.1115 0.221937L20.5503 4.66068C20.8462 4.9566 20.8462 5.40047 20.5503 5.69639L7.97384 18.2728C7.89986 18.3468 7.75191 18.4208 7.60395 18.4948L1.68562 19.9743C1.16777 20.1223 0.649918 19.6044 0.797876 19.0866L2.27746 13.1683C2.27746 13.0203 2.35144 12.9463 2.49939 12.7984L15.0758 0.221937ZM12.6345 4.73466L3.68306 13.6861L2.57337 18.1988L7.08609 17.0892L16.0376 8.13769L12.6345 4.73466ZM13.6702 3.69895L15.5937 1.7755L18.9967 5.17853L17.0733 7.10199L13.6702 3.69895Z"
      fill="#95A1B4"
    />
  </svg>
);

export default EditReportIcon;
